import query from "./query/de";

export default {
  label: "Gruppen",
  createGroup: "Gruppe Erstellen",
  updateGroup: "Gruppe Bearbeiten",
  groupDetails: "Gruppe Details",
  query,
};
